import { useMemo } from "react";

import { useAggregatedMessageStats } from "src/cep/messages/hooks/use-aggregated-message-stats";
import { ALL_TIME } from "src/cep/utils";

export type CampaignHasSends = {
  hasSends: boolean;
  isLoading: boolean;
};

export function useCampaignHasSends(
  messages: readonly { id: string | number }[] | null | undefined,
): CampaignHasSends {
  const messageIds = useMemo(
    () => (messages ?? []).map((message) => String(message.id)).sort(),
    [messages],
  );

  const { aggregatedStats, isLoading } = useAggregatedMessageStats(
    messageIds,
    ALL_TIME,
  );

  return {
    hasSends: (aggregatedStats?.totalSent ?? 0) > 0,
    // A campaign with no messages has no query to wait on.
    isLoading: messageIds.length > 0 && isLoading,
  };
}
